import { render, staticRenderFns } from "./register-result.vue?vue&type=template&id=cffebe28&scoped=true&"
import script from "./register-result.vue?vue&type=script&lang=js&"
export * from "./register-result.vue?vue&type=script&lang=js&"
import style0 from "./register-result.vue?vue&type=style&index=0&id=cffebe28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffebe28",
  null
  
)

export default component.exports